import { Component, OnInit } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { NgxRolesService } from 'ngx-permissions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private _applicationInsights: ApplicationInsights,private roles:NgxRolesService) {

  }
  ngOnInit() {
    this._applicationInsights.loadAppInsights()
    //console.log(this.roles.getRoles())
  }

}
